<mat-card class="mb-3 mb-md-2 izy-sharp-bl col-md-12 d-flex flex-column h-100 custom-card">
  <mat-card-header>
    <!-- Titolo e sottotitolo insieme in un wrapper: mat-card-header proietta
         mat-card-title/subtitle in una sua riga flex, quindi un h5 "nudo"
         finirebbe accanto al sottotitolo invece che sopra. -->
    <div class="me-auto">
      <h5 class="mb-1">Distribuzione fatturato per cliente</h5>
      <mat-card-subtitle>
        Migliori clienti per fatturato
        <span *ngIf="totalInvoices > 0"
          >({{ totalInvoices }} fatture totali nel {{selectedYear}})</span
        >
      </mat-card-subtitle>
    </div>
  </mat-card-header>

  <mat-card-content class="mt-2">
    <div *ngIf="isLoading" class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <div
      *ngIf="!isLoading && !errorMessage"
      class="chart-container"
    >
      <canvas
        baseChart
        [data]="pieChartData"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"
        [type]="pieChartType"
        style="cursor: pointer;">
      >
      </canvas>
    </div>
  </mat-card-content>

  <mat-card-actions class="d-flex justify-content-end">
    <button mat-raised-button color="primary" class="custom-button-border" (click)="refreshData()">
      Ricarica dati
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
